// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ServiceAreasRouteImport } from './routes/service-areas'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as QuoteRouteImport } from './routes/quote'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PreviewLightRouteImport } from './routes/preview-light'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesSolidColorEpoxyFlooringRouteImport } from './routes/services.solid-color-epoxy-flooring'
import { Route as ServicesPolyasparticFloorCoatingsRouteImport } from './routes/services.polyaspartic-floor-coatings'
import { Route as ServicesMetallicEpoxyFlooringRouteImport } from './routes/services.metallic-epoxy-flooring'
import { Route as ServicesGrindAndSealConcreteRouteImport } from './routes/services.grind-and-seal-concrete'
import { Route as ServicesFlakeEpoxyFlooringRouteImport } from './routes/services.flake-epoxy-flooring'
import { Route as ServicesConcreteResurfacingRouteImport } from './routes/services.concrete-resurfacing'
import { Route as ServiceAreasOkotoksAbRouteImport } from './routes/service-areas.okotoks-ab'
import { Route as ServiceAreasCochraneAbRouteImport } from './routes/service-areas.cochrane-ab'
import { Route as ServiceAreasChestermereAbRouteImport } from './routes/service-areas.chestermere-ab'
import { Route as ServiceAreasCalgaryAbRouteImport } from './routes/service-areas.calgary-ab'
import { Route as ServiceAreasAirdrieAbRouteImport } from './routes/service-areas.airdrie-ab'
import { Route as ResourcesIndexRouteImport } from './routes/resources.index'
import { Route as ResourcesGarageFloorCoatingMaintenanceRouteImport } from './routes/resources.garage-floor-coating-maintenance'
import { Route as ResourcesGarageFloorCoatingCostRouteImport } from './routes/resources.garage-floor-coating-cost'
import { Route as ResourcesGarageFloorCoatingColorsRouteImport } from './routes/resources.garage-floor-coating-colors'
import { Route as ResourcesEpoxyVsPolyasparticRouteImport } from './routes/resources.epoxy-vs-polyaspartic'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogMetallicEpoxyDesignIdeasRouteImport } from './routes/blog.metallic-epoxy-design-ideas'
import { Route as BlogGarageRenovationTipsRouteImport } from './routes/blog.garage-renovation-tips'
import { Route as BlogConcreteCoatingMaintenanceRouteImport } from './routes/blog.concrete-coating-maintenance'
import { Route as BlogCommercialFloorCoatingSolutionsRouteImport } from './routes/blog.commercial-floor-coating-solutions'
import { Route as BlogBestGarageFloorCoatingsRouteImport } from './routes/blog.best-garage-floor-coatings'

const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ServiceAreasRoute = ServiceAreasRouteImport.update({
            id: '/service-areas',path: '/service-areas',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const QuoteRoute = QuoteRouteImport.update({
            id: '/quote',path: '/quote',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PreviewLightRoute = PreviewLightRouteImport.update({
            id: '/preview-light',path: '/preview-light',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const FaqsRoute = FaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesSolidColorEpoxyFlooringRoute = ServicesSolidColorEpoxyFlooringRouteImport.update({
            id: '/solid-color-epoxy-flooring',path: '/solid-color-epoxy-flooring',getParentRoute: () => ServicesRoute
          })
const ServicesPolyasparticFloorCoatingsRoute = ServicesPolyasparticFloorCoatingsRouteImport.update({
            id: '/polyaspartic-floor-coatings',path: '/polyaspartic-floor-coatings',getParentRoute: () => ServicesRoute
          })
const ServicesMetallicEpoxyFlooringRoute = ServicesMetallicEpoxyFlooringRouteImport.update({
            id: '/metallic-epoxy-flooring',path: '/metallic-epoxy-flooring',getParentRoute: () => ServicesRoute
          })
const ServicesGrindAndSealConcreteRoute = ServicesGrindAndSealConcreteRouteImport.update({
            id: '/grind-and-seal-concrete',path: '/grind-and-seal-concrete',getParentRoute: () => ServicesRoute
          })
const ServicesFlakeEpoxyFlooringRoute = ServicesFlakeEpoxyFlooringRouteImport.update({
            id: '/flake-epoxy-flooring',path: '/flake-epoxy-flooring',getParentRoute: () => ServicesRoute
          })
const ServicesConcreteResurfacingRoute = ServicesConcreteResurfacingRouteImport.update({
            id: '/concrete-resurfacing',path: '/concrete-resurfacing',getParentRoute: () => ServicesRoute
          })
const ServiceAreasOkotoksAbRoute = ServiceAreasOkotoksAbRouteImport.update({
            id: '/okotoks-ab',path: '/okotoks-ab',getParentRoute: () => ServiceAreasRoute
          })
const ServiceAreasCochraneAbRoute = ServiceAreasCochraneAbRouteImport.update({
            id: '/cochrane-ab',path: '/cochrane-ab',getParentRoute: () => ServiceAreasRoute
          })
const ServiceAreasChestermereAbRoute = ServiceAreasChestermereAbRouteImport.update({
            id: '/chestermere-ab',path: '/chestermere-ab',getParentRoute: () => ServiceAreasRoute
          })
const ServiceAreasCalgaryAbRoute = ServiceAreasCalgaryAbRouteImport.update({
            id: '/calgary-ab',path: '/calgary-ab',getParentRoute: () => ServiceAreasRoute
          })
const ServiceAreasAirdrieAbRoute = ServiceAreasAirdrieAbRouteImport.update({
            id: '/airdrie-ab',path: '/airdrie-ab',getParentRoute: () => ServiceAreasRoute
          })
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ResourcesRoute
          })
const ResourcesGarageFloorCoatingMaintenanceRoute = ResourcesGarageFloorCoatingMaintenanceRouteImport.update({
            id: '/garage-floor-coating-maintenance',path: '/garage-floor-coating-maintenance',getParentRoute: () => ResourcesRoute
          })
const ResourcesGarageFloorCoatingCostRoute = ResourcesGarageFloorCoatingCostRouteImport.update({
            id: '/garage-floor-coating-cost',path: '/garage-floor-coating-cost',getParentRoute: () => ResourcesRoute
          })
const ResourcesGarageFloorCoatingColorsRoute = ResourcesGarageFloorCoatingColorsRouteImport.update({
            id: '/garage-floor-coating-colors',path: '/garage-floor-coating-colors',getParentRoute: () => ResourcesRoute
          })
const ResourcesEpoxyVsPolyasparticRoute = ResourcesEpoxyVsPolyasparticRouteImport.update({
            id: '/epoxy-vs-polyaspartic',path: '/epoxy-vs-polyaspartic',getParentRoute: () => ResourcesRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogMetallicEpoxyDesignIdeasRoute = BlogMetallicEpoxyDesignIdeasRouteImport.update({
            id: '/metallic-epoxy-design-ideas',path: '/metallic-epoxy-design-ideas',getParentRoute: () => BlogRoute
          })
const BlogGarageRenovationTipsRoute = BlogGarageRenovationTipsRouteImport.update({
            id: '/garage-renovation-tips',path: '/garage-renovation-tips',getParentRoute: () => BlogRoute
          })
const BlogConcreteCoatingMaintenanceRoute = BlogConcreteCoatingMaintenanceRouteImport.update({
            id: '/concrete-coating-maintenance',path: '/concrete-coating-maintenance',getParentRoute: () => BlogRoute
          })
const BlogCommercialFloorCoatingSolutionsRoute = BlogCommercialFloorCoatingSolutionsRouteImport.update({
            id: '/commercial-floor-coating-solutions',path: '/commercial-floor-coating-solutions',getParentRoute: () => BlogRoute
          })
const BlogBestGarageFloorCoatingsRoute = BlogBestGarageFloorCoatingsRouteImport.update({
            id: '/best-garage-floor-coatings',path: '/best-garage-floor-coatings',getParentRoute: () => BlogRoute
          })





const BlogRouteChildren = {
  BlogBestGarageFloorCoatingsRoute: BlogBestGarageFloorCoatingsRoute,BlogCommercialFloorCoatingSolutionsRoute: BlogCommercialFloorCoatingSolutionsRoute,BlogConcreteCoatingMaintenanceRoute: BlogConcreteCoatingMaintenanceRoute,BlogGarageRenovationTipsRoute: BlogGarageRenovationTipsRoute,BlogMetallicEpoxyDesignIdeasRoute: BlogMetallicEpoxyDesignIdeasRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const ResourcesRouteChildren = {
  ResourcesEpoxyVsPolyasparticRoute: ResourcesEpoxyVsPolyasparticRoute,ResourcesGarageFloorCoatingColorsRoute: ResourcesGarageFloorCoatingColorsRoute,ResourcesGarageFloorCoatingCostRoute: ResourcesGarageFloorCoatingCostRoute,ResourcesGarageFloorCoatingMaintenanceRoute: ResourcesGarageFloorCoatingMaintenanceRoute,ResourcesIndexRoute: ResourcesIndexRoute
}

const ResourcesRouteWithChildren = ResourcesRoute._addFileChildren(ResourcesRouteChildren)




const ServiceAreasRouteChildren = {
  ServiceAreasAirdrieAbRoute: ServiceAreasAirdrieAbRoute,ServiceAreasCalgaryAbRoute: ServiceAreasCalgaryAbRoute,ServiceAreasChestermereAbRoute: ServiceAreasChestermereAbRoute,ServiceAreasCochraneAbRoute: ServiceAreasCochraneAbRoute,ServiceAreasOkotoksAbRoute: ServiceAreasOkotoksAbRoute
}

const ServiceAreasRouteWithChildren = ServiceAreasRoute._addFileChildren(ServiceAreasRouteChildren)




const ServicesRouteChildren = {
  ServicesConcreteResurfacingRoute: ServicesConcreteResurfacingRoute,ServicesFlakeEpoxyFlooringRoute: ServicesFlakeEpoxyFlooringRoute,ServicesGrindAndSealConcreteRoute: ServicesGrindAndSealConcreteRoute,ServicesMetallicEpoxyFlooringRoute: ServicesMetallicEpoxyFlooringRoute,ServicesPolyasparticFloorCoatingsRoute: ServicesPolyasparticFloorCoatingsRoute,ServicesSolidColorEpoxyFlooringRoute: ServicesSolidColorEpoxyFlooringRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BlogRoute: BlogRouteWithChildren,ContactRoute: ContactRoute,FaqsRoute: FaqsRoute,GalleryRoute: GalleryRoute,PreviewLightRoute: PreviewLightRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,QuoteRoute: QuoteRoute,ResourcesRoute: ResourcesRouteWithChildren,ServiceAreasRoute: ServiceAreasRouteWithChildren,ServicesRoute: ServicesRouteWithChildren,TermsOfServiceRoute: TermsOfServiceRoute,ThankYouRoute: ThankYouRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)